import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (localStorage.getItem("entiteSchoolCode")) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  }
  
  const sousEntiteId = localStorage.getItem("sousEntiteId")
  if (sousEntiteId) {
    config.headers['etablissementId'] = `${sousEntiteId}`;
  } else {
    config.headers['etablissementId'] =  null;
  }

  return config;
});

export const loginAdmin = async (values) => {
  return await axios.post(
    BASE_URL("signin"),
    values
  );
};

export const changePasswordAdmin = async (values) => {
  return await axios.post(
    BASE_URL("changermotdepasse"),
    values
  );
};

export const resetPasswordAdmin = async (values) => {
  return await axios.post(
    BASE_URL("reinitialiserpassword"),
    values
  );
};